import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PublicRoute = ({ children }) => {
    const { isAuthenticated, userRole } = useAuth();

    if (isAuthenticated) {
        // redirect based on role
        if (userRole === 'admin') return <Navigate to="/admin/dashboard" replace />;
        if (userRole === 'organizer') return <Navigate to="/organizer/dashboard" replace />;
        if (userRole === 'agent') return <Navigate to="/agent/dashboard" replace />;
        return <Navigate to="/" replace />; // normal user
    }

    return children;
};

export default PublicRoute;
